import script from "./trackingTableModal.vue?vue&type=script&setup=true&lang=jsx"
export * from "./trackingTableModal.vue?vue&type=script&setup=true&lang=jsx"

import "./trackingTableModal.vue?vue&type=style&index=0&id=51d5000a&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51d5000a"]])

export default __exports__